window.RiseGlobalCwvPatches = {
  scheduleAfterInteraction(callback) {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(callback);
    });
  },

  scheduleHeaderMetricsUpdate(instance) {
    if (!instance?.header || instance.headerMetricsRaf) return;

    instance.headerMetricsRaf = window.requestAnimationFrame(() => {
      instance.headerMetricsRaf = null;
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(instance.header.getBoundingClientRect().bottom - instance.borderOffset)}px`
      );
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    });
  },

  cleanupHeaderMetrics(instance) {
    if (!instance?.headerMetricsRaf) return;
    window.cancelAnimationFrame(instance.headerMetricsRaf);
    instance.headerMetricsRaf = null;
  },

  createSliderResizeObserver(instance) {
    instance.onResizeObserved = rafThrottle(() => instance.initPages());
    return new ResizeObserver(() => instance.onResizeObserved());
  },

  createSliderScrollHandler(instance) {
    instance.onSliderScroll = rafThrottle(() => instance.update());
    return instance.onSliderScroll;
  },

  createSlideVisibilityScrollHandler(instance) {
    instance.onSlideVisibilityScroll = rafThrottle(() => instance.setSlideVisibility());
    return instance.onSlideVisibilityScroll;
  },

  getPassiveScrollOptions() {
    return { passive: true };
  },
};
